import DriverSupportApi from "../../services/api/DriverSupport";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import qs from "qs";

function handleError(err) {
  console.log("error in rider payouts actions:", err);
}

export const setRiderPayouts = (payload) => {
  return {
    type: ActionTypes.SET_RIDER_PAYOUTS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DRIVER_SUPPORT,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_RIDER_PAYOUTS,
    payload,
  };
};

export const getRiderPayouts = (filters) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const queryParams = qs.stringify(filters, { addQueryPrefix: true });
    const response = await DriverSupportApi.getRiderPayouts(queryParams);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setRiderPayouts(response));
      if (Object.keys(filters).length > 0) {
        dispatch(setActiveFilters(filters));
      } else if (Object.keys(filters).length === 0) {
        dispatch(resetState({ state: "activeFilters" }));
      }
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.RETRIEVAL_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
